package com.tovtalk.domain.entity

/**
 * App Settings - הגדרות אפליקציה
 */
data class AppSettings(
    val id: Int,
    val appName: String,
    val currency: String,
    val coinValue: Double,
    
    // Limits
    val minRedeemCoins: Int,
    val minFollowersForLive: Int,
    val maxUploadDaily: Int,
    val maxStoryDaily: Int,
    val maxCommentDaily: Int,
    val maxCommentReplyDaily: Int,
    val maxPostPins: Int,
    val maxCommentPins: Int,
    val maxImagesPerPost: Int,
    val maxUserLinks: Int,
    val maxFileSizeMb: Int,
    
    // Live Streaming
    val liveMinViewers: Int,
    val liveTimeout: Int,
    val liveBattle: Boolean,
    val liveDummyShow: Boolean,
    
    // Features
    val isCompress: Boolean,
    val isDeepAr: Boolean,
    val isWithdrawalOn: Boolean,
    val isContentModeration: Boolean,
    val gifSupport: Boolean,
    val watermarkStatus: Boolean,
    
    // Integrations
    val zegoAppId: String?,
    val zegoAppSign: String?,
    val sightEngineApiUser: String?,
    val sightEngineApiSecret: String?,
    val giphyKey: String?,
    val deeparAndroidKey: String?,
    val deeparIosKey: String?,
    
    // URLs
    val privacyPolicy: String?,
    val termsOfUse: String?,
    val helpMail: String?,
    
    // Related Data
    val languages: List<Language> = emptyList(),
    val musicCategories: List<MusicCategory> = emptyList(),
    val reportReasons: List<ReportReason> = emptyList(),
    val userLevels: List<UserLevel> = emptyList()
)

/**
 * Language - שפה
 */
data class Language(
    val id: Int,
    val code: String,
    val name: String,
    val nativeName: String,
    val isRtl: Boolean,
    val isDefault: Boolean,
    val csvFileUrl: String?,
    val isActive: Boolean
)

/**
 * Report Reason - סיבת דיווח
 */
data class ReportReason(
    val id: Int,
    val reason: String,
    val description: String?
)

/** Option for report dialog (id + display title from API). */
data class ReportReasonOption(
    val id: Int,
    val title: String
)

/**
 * User Level - רמת משתמש
 */
data class UserLevel(
    val id: Int,
    val level: Int,
    val title: String,
    val minCoins: Int,
    val maxCoins: Int,
    val badgeUrl: String
)

/**
 * OnBoarding Page
 */
data class OnBoardingPage(
    val id: Int,
    val title: String,
    val description: String,
    val imageUrl: String,
    val order: Int
)
